export const getSymbol = (str) => {
  const commaIdx = str.indexOf(',');
  str = str.substring(0, commaIdx).toLowerCase();
  return str;
};
